import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import AnimationPreviewStage from './AnimationStage/AnimationPreviewStage';

const Container = styled.div.attrs({
  className: 'animation-root',
})`
  display: flex;
  flex-direction: row;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

function AnimationPreview() {
  const store_current = store.current;
  const store_preview = store.preview;
  const currentViewName = store_current?.data.name;

  useEffect(() => {
    if (currentViewName) document.title = currentViewName;
  }, [currentViewName]);

  useEffect(() => {
    return () => {
      store_preview?.reset();
    };
  }, [store_preview]);

  // Guarded on the document, not on its name: an animation with an empty
  // `name` (the AnimationSchema default) is still a renderable preview, and
  // gating on the title would show a blank page for it.
  return (
    store_current && (
      <Container>
        <AnimationPreviewStage />
      </Container>
    )
  );
}

export default observer(AnimationPreview);
